export type OptionCode = number | string | null;

export interface Option {
  code: OptionCode;
  name: string;
  selectable: boolean;
  children?: Option[];
  parentCode?: OptionCode;
  chipText?: string;
}

export const ITEM_SELECTION_STATUS = {
  CHECKED: 'CHECKED',
  INDETERMINATE: 'INDETERMINATE',
  UNCHECKED: 'UNCHECKED',
};

export const getLeafNodes = (option: Option): Option[] =>
  option.children?.length ? option.children.flatMap(getLeafNodes) : [option];

export const getItemSelectionStatus = (option: Option, selectedItems: OptionCode[] = []): string => {
  const leafNodes = getLeafNodes(option);
  const selectedLeafNodes = leafNodes.filter((node: Option) =>
    selectedItems.find((code: OptionCode) => node.code === code),
  );

  if (!selectedLeafNodes.length) return ITEM_SELECTION_STATUS.UNCHECKED;
  if (selectedLeafNodes.length === leafNodes.length) return ITEM_SELECTION_STATUS.CHECKED;
  return ITEM_SELECTION_STATUS.INDETERMINATE;
};

const defaultOptionFormatter = (childOption: Option, parentOption: Option): Option => ({
  ...childOption,
  name: `${parentOption.selectable ? `${parentOption.name} > ${childOption.name}` : childOption.name}`,
});

export const getSelectedAncestors = (
  option: Option,
  selectedItems: OptionCode[],
  optionFormatter?: (childOption: Option, parentOption: Option) => Option,
): Option[] => {
  if (option.selectable && getItemSelectionStatus(option, selectedItems) === ITEM_SELECTION_STATUS.CHECKED)
    return [option];
  if (option.children?.length)
    return option.children.flatMap((i) => {
      const formattedOption = optionFormatter ? optionFormatter(i, option) : defaultOptionFormatter(i, option);
      return getSelectedAncestors(formattedOption, selectedItems, optionFormatter);
    });
  return [];
};
